// tempexp_18907-full-file
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { BuySubscriptionSelectors } from 'reactApp/modules/buySubscription/buySubscription.module';
import { DiscountInOutflowSaveModalType } from 'reactApp/ui/DiscountInOutflow/DiscountInOutflowSaveModal/DiscountInOutflowSaveModal';
import { renderDiscountInOutflowSaveModal } from 'reactApp/ui/DiscountInOutflow/DiscountInOutflowSaveModal/DiscountInOutflowSaveModal.helpers';

export const useOpenDiscountInOutflowSaveModalCallback = ({ subscription }) => {
    const { status: discountInOutflowSave, period } = useSelector(BuySubscriptionSelectors.getDiscountInOutflowSave);

    return useCallback(() => {
        if (!discountInOutflowSave) {
            return;
        }
        renderDiscountInOutflowSaveModal({
            analyticType: DiscountInOutflowSaveModalType.start,
            forceDarkTheme: true,
            subscription,
            availabilityPeriod: period,
        });
    }, [discountInOutflowSave, subscription, period]);
};
